import { render, staticRenderFns } from "./DialogFreigabe.vue?vue&type=template&id=dde21c9a&scoped=true"
import script from "./DialogFreigabe.vue?vue&type=script&lang=ts"
export * from "./DialogFreigabe.vue?vue&type=script&lang=ts"
import style0 from "./DialogFreigabe.vue?vue&type=style&index=0&id=dde21c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde21c9a",
  null
  
)

export default component.exports